import { AreaButton } from "@/main/components/shared/styles";
import { FormControlLabel } from "@mui/material";
import styled from "styled-components";

export const CustomAreaButton = styled(AreaButton)`
	margin: -3.5rem 0 0 auto;
	top: 3rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		margin: -1rem auto 1rem 0;
	}
`;

export const CardArea = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;
	flex-wrap: wrap;
	gap: 0.4rem;

	padding: 1rem;

	background: #ffffff;

	@media (max-width: 560px) {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		justify-items: center;
		padding: 0;
		gap: 0.2rem;
		width: 100%;
	}
`;

export const Row = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	align-items: start;
	gap: 1rem;
	margin-bottom: 1rem;

	@media (max-width: 560px) {
		grid-template-columns: 1fr;
	}
`;

export const RowWrap = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(348.33px, 1fr));
	gap: 1rem;
	margin-bottom: 1rem;
`;

export const SmallerInputLabel = styled.div`
	label.MuiInputLabel-root.MuiInputLabel-formControl {
		font-size: 1em;
	}
`;
export const FieldWrapper = styled.div`
	min-width: 0;

	&& .MuiAutocomplete-root:not(.Mui-focused) .MuiAutocomplete-inputRoot {
		flex-wrap: nowrap;
	}

	&& .MuiAutocomplete-root .MuiChip-root {
		min-width: 0;
		max-width: calc(100% - 6px) !important;
	}

	&& .MuiAutocomplete-root:not(.Mui-focused) .MuiChip-root {
		flex-shrink: 1;
	}

	&& .MuiAutocomplete-root:not(.Mui-focused) span.MuiAutocomplete-tag {
		flex-shrink: 0;
	}

	&& .MuiAutocomplete-root.Mui-focused .MuiAutocomplete-inputRoot {
		max-height: 168px;
		overflow-y: auto;
	}
`;

export const GridCheckbox = styled.div`
	display: flex;
	align-items: center;

	.MuiFormControlLabel-root {
		margin: 0;
	}

	.MuiFormControlLabel-root {
		margin: 0;
		gap: 8px;
	}

	.MuiCheckbox-root {
		padding: 3px;
	}
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	gap: 1rem;
	justify-content: flex-end;
	margin-left: auto;
	grid-column: 1 / -1;

	@media (max-width: 420px) {
		flex-direction: column;
		width: 100%;
		margin-left: 0;

		> button {
			width: 100%;
			max-width: unset !important;
		}
	}
`;

export const RowBottom = styled.div`
	display: grid;
	grid-template-columns: minmax(max-content, 1fr) repeat(2, minmax(0, 1fr));
	gap: 1rem;
	align-items: center;
	width: 100%;
	margin-bottom: 1rem;

	@media (max-width: 900px) {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 0.1rem;
	}
`;

export const FavoriteSearchLabel = styled(FormControlLabel)`
	&& .MuiFormControlLabel-label {
		white-space: nowrap;
	}
`;
export const PredefinedSearchLabel = styled(FormControlLabel)`
	&& .MuiFormControlLabel-label {
		white-space: nowrap;
	}
`;

export const IconArea = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.4rem;
	min-width: 0;

	@media (max-width: 910px) {
		flex-direction: column;
		align-items: flex-start;
		flex-wrap: nowrap;
	}
`;

export const FavPredefinedGroup = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.4rem;
	min-width: 0;

	@media (max-width: 910px) {
		flex-direction: column;
		align-items: flex-start;
		flex-wrap: nowrap;
	}
`;

export const CheckboxColumns = styled.div`
	grid-column: 2 / -1;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 1rem;
	align-items: center;
	min-width: 0;

	@media (max-width: 910px) {
		grid-column: auto;
		grid-template-columns: minmax(0, 1fr);
		gap: 0.4rem;
	}
`;

export const CheckboxPair = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.4rem;
	min-width: 0;

	@media (max-width: 910px) {
		flex-direction: column;
		align-items: flex-start;
		flex-wrap: nowrap;
	}
`;
